export default "__VITE_ASSET__CQVAsHCL__"